module.exports = __webpack_public_path__ + "static/media/melaku.3d85200a.png";